import script from "./TaggingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TaggingPage.vue?vue&type=script&setup=true&lang=js"

import "./TaggingPage.vue?vue&type=style&index=0&id=78b005df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b005df"]])

export default __exports__